import React from 'react';

const RiderCharacter = ({ width = 220, height = 271, style = {} }) => (
  <svg
    viewBox="0 0 260 320"
    width={width}
    height={height}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="rSkin" cx="40%" cy="35%" r="65%">
        <stop offset="0%" stopColor="#a06030" />
        <stop offset="100%" stopColor="#5c3317" />
      </radialGradient>
      <radialGradient id="rHead" cx="38%" cy="32%" r="65%">
        <stop offset="0%" stopColor="#9a5d28" />
        <stop offset="55%" stopColor="#7a4520" />
        <stop offset="100%" stopColor="#5c2e14" />
      </radialGradient>
      <linearGradient id="rJacket" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f5c800" />
        <stop offset="55%" stopColor="#dea800" />
        <stop offset="100%" stopColor="#b88800" />
      </linearGradient>
      <linearGradient id="rBag" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f7d700" />
        <stop offset="100%" stopColor="#c8a800" />
      </linearGradient>
      <linearGradient id="rPants" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#1e2535" />
        <stop offset="100%" stopColor="#0f1520" />
      </linearGradient>
      <linearGradient id="rShoe" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#f2f2f2" />
        <stop offset="100%" stopColor="#cccccc" />
      </linearGradient>
      <radialGradient id="rHelmet" cx="35%" cy="30%" r="65%">
        <stop offset="0%" stopColor="#ffe040" />
        <stop offset="60%" stopColor="#f5c800" />
        <stop offset="100%" stopColor="#b08800" />
      </radialGradient>
      <filter id="rDrop" x="-25%" y="-25%" width="150%" height="150%">
        <feDropShadow dx="2" dy="4" stdDeviation="3" floodOpacity="0.25" />
      </filter>
    </defs>

    {/* Ground shadow */}
    <ellipse cx="148" cy="314" rx="85" ry="9" fill="rgba(0,0,0,0.22)" />

    {/* ===== BIKE ===== */}
    {/* Tire */}
    <circle cx="60" cy="262" r="52" fill="#1a1a1a" stroke="#2a2a2a" strokeWidth="2" />
    {/* Rim */}
    <circle cx="60" cy="262" r="44" fill="none" stroke="#444" strokeWidth="5" />
    <circle cx="60" cy="262" r="40" fill="none" stroke="#383838" strokeWidth="1" />
    {/* Spokes */}
    <line x1="68" y1="262" x2="100" y2="262" stroke="#555" strokeWidth="1.5" />
    <line x1="66" y1="256" x2="88" y2="234" stroke="#555" strokeWidth="1.5" />
    <line x1="60" y1="254" x2="60" y2="222" stroke="#555" strokeWidth="1.5" />
    <line x1="54" y1="256" x2="32" y2="234" stroke="#555" strokeWidth="1.5" />
    <line x1="52" y1="262" x2="20" y2="262" stroke="#555" strokeWidth="1.5" />
    <line x1="54" y1="268" x2="32" y2="290" stroke="#555" strokeWidth="1.5" />
    <line x1="60" y1="270" x2="60" y2="302" stroke="#555" strokeWidth="1.5" />
    <line x1="66" y1="268" x2="88" y2="290" stroke="#555" strokeWidth="1.5" />
    {/* Hub */}
    <circle cx="60" cy="262" r="9" fill="#555" stroke="#666" strokeWidth="2" />
    <circle cx="60" cy="262" r="4" fill="#777" />
    {/* Tire shine */}
    <path d="M16 238 Q6 262 18 286" stroke="rgba(255,255,255,0.07)" strokeWidth="7" fill="none" strokeLinecap="round" />
    {/* Fork blades */}
    <path d="M50 214 Q52 188 60 170" stroke="#2a2a3a" strokeWidth="5" fill="none" strokeLinecap="round" />
    <path d="M70 214 Q72 188 78 170" stroke="#2a2a3a" strokeWidth="5" fill="none" strokeLinecap="round" />
    {/* Fork crown */}
    <path d="M60 170 Q69 167 78 170" stroke="#3a3a4a" strokeWidth="5" fill="none" strokeLinecap="round" />
    {/* Stem */}
    <rect x="66" y="150" width="7" height="24" rx="3" fill="#3a3a4a" />
    {/* Handlebar */}
    <path d="M50 155 Q70 149 93 151" stroke="#3a3a4a" strokeWidth="7" fill="none" strokeLinecap="round" />
    <rect x="43" y="150" width="13" height="9" rx="4" fill="#222" stroke="#333" strokeWidth="1" />
    <rect x="90" y="147" width="13" height="9" rx="4" fill="#222" stroke="#333" strokeWidth="1" />
    {/* Down tube (partial) */}
    <path d="M78 170 Q106 200 116 235" stroke="#2a2a3a" strokeWidth="6" fill="none" strokeLinecap="round" />

    {/* ===== DELIVERY BAG ON BACK ===== */}
    <rect x="106" y="140" width="36" height="92" rx="5" fill="url(#rBag)" stroke="#b08800" strokeWidth="2" filter="url(#rDrop)" />
    {/* Top flap */}
    <path d="M106 140 Q124 130 142 140" fill="#c8a000" stroke="#b08800" strokeWidth="1.5" />
    {/* Green company panel */}
    <rect x="110" y="158" width="28" height="38" rx="3" fill="#1e7a00" stroke="#136000" strokeWidth="1.5" />
    <text x="124" y="173" textAnchor="middle" fontSize="8" fill="#f5d700" fontWeight="bold" fontFamily="Arial, sans-serif">RUSH</text>
    <text x="124" y="186" textAnchor="middle" fontSize="7" fill="#f5d700" fontFamily="Arial, sans-serif">EATS</text>
    {/* Reflective stripe */}
    <rect x="107" y="208" width="33" height="5" rx="2" fill="rgba(255,255,255,0.45)" />
    {/* Bag bottom */}
    <path d="M106 230 Q124 236 142 230" fill="none" stroke="#b08800" strokeWidth="1.5" />
    {/* Pizza peeking out */}
    <ellipse cx="126" cy="140" rx="13" ry="6" fill="#e88030" stroke="#c06818" strokeWidth="1.5" />
    <ellipse cx="126" cy="138" rx="12" ry="5" fill="#f0b858" />
    <circle cx="122" cy="137" r="1.8" fill="#cc2200" />
    <circle cx="129" cy="136" r="1.8" fill="#cc2200" />
    <circle cx="126" cy="139" r="1.8" fill="#1e7a00" />
    {/* Strap on left side */}
    <path d="M110 140 Q108 156 110 178" stroke="#a08000" strokeWidth="4" fill="none" strokeLinecap="round" />
    {/* Strap crossing shoulder to chest */}
    <path d="M142 140 Q154 138 161 150 Q165 160 163 170" stroke="#a08000" strokeWidth="4" fill="none" strokeLinecap="round" />

    {/* ===== SHOES ===== */}
    {/* Left shoe */}
    <ellipse cx="138" cy="306" rx="22" ry="9" fill="url(#rShoe)" stroke="#ccc" strokeWidth="1.5" />
    <path d="M118 304 Q122 297 140 299 Q148 301 147 307 Q130 310 118 304 Z" fill="#e8e8e8" />
    <path d="M117 309 Q132 312 148 309" stroke="#f5c800" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    {/* Right shoe */}
    <ellipse cx="176" cy="309" rx="23" ry="9" fill="url(#rShoe)" stroke="#ccc" strokeWidth="1.5" />
    <path d="M155 307 Q160 300 178 302 Q186 304 185 309 Q168 313 155 307 Z" fill="#e8e8e8" />
    <path d="M154 311 Q170 315 186 311" stroke="#f5c800" strokeWidth="2.5" fill="none" strokeLinecap="round" />

    {/* ===== PANTS ===== */}
    <path d="M130 250 Q124 270 122 289 Q126 298 142 297 Q150 295 149 287 Q147 266 144 250 Z"
      fill="url(#rPants)" stroke="#111" strokeWidth="2" strokeLinejoin="round" />
    <path d="M162 252 Q166 272 168 289 Q172 298 186 296 Q194 294 192 285 Q190 266 184 252 Z"
      fill="url(#rPants)" stroke="#111" strokeWidth="2" strokeLinejoin="round" />
    <path d="M132 252 Q129 271 130 287" stroke="rgba(100,130,200,0.28)" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    <path d="M182 254 Q183 272 183 286" stroke="rgba(100,130,200,0.28)" strokeWidth="2.5" fill="none" strokeLinecap="round" />

    {/* ===== JACKET BODY ===== */}
    <path d="M140 142 Q132 164 130 207 Q129 230 134 250 L196 250 Q201 230 200 207 Q198 164 188 142 Z"
      fill="url(#rJacket)" stroke="#111" strokeWidth="2.5" strokeLinejoin="round" />
    {/* Left shadow panel */}
    <path d="M140 142 Q132 165 130 210 Q129 232 134 250 L165 250 L165 142 Z" fill="rgba(0,0,0,0.09)" />
    {/* Green V-collar */}
    <path d="M153 142 L146 163 L165 172 L184 163 L177 142 Z" fill="#1e7a00" stroke="#136000" strokeWidth="1" />
    {/* Zipper */}
    <line x1="165" y1="142" x2="165" y2="250" stroke="#a08800" strokeWidth="2" strokeDasharray="5,4" />
    {/* Green sleeve stripes */}
    <path d="M140 168 Q134 174 132 184" stroke="#1e7a00" strokeWidth="7" fill="none" strokeLinecap="round" />
    <path d="M190 168 Q196 174 198 184" stroke="#1e7a00" strokeWidth="7" fill="none" strokeLinecap="round" />
    {/* Chest patch */}
    <rect x="172" y="172" width="24" height="24" rx="3" fill="#1e7a00" stroke="#136000" strokeWidth="1.5" />
    <text x="184" y="182" textAnchor="middle" fontSize="5.5" fill="#f5d700" fontWeight="bold" fontFamily="Arial, sans-serif">RUSH</text>
    <text x="184" y="191" textAnchor="middle" fontSize="5" fill="#f5d700" fontFamily="Arial, sans-serif">EATS</text>

    {/* ===== ARMS ===== */}
    {/* Left arm reaching toward handlebar */}
    <path d="M140 154 Q120 168 104 173 Q98 176 94 183"
      fill="none" stroke="#111" strokeWidth="24" strokeLinecap="round" opacity="0.15" />
    <path d="M140 154 Q120 168 104 173 Q98 176 94 183"
      fill="none" stroke="#dea800" strokeWidth="20" strokeLinecap="round" />
    <path d="M140 154 Q134 159 128 165" stroke="#1e7a00" strokeWidth="8" fill="none" strokeLinecap="round" />
    <ellipse cx="93" cy="184" rx="9" ry="7" fill="url(#rSkin)" stroke="#3a1a08" strokeWidth="1.5" transform="rotate(-25,93,184)" />
    {/* Right arm slightly bent */}
    <path d="M190 154 Q206 175 208 210 Q209 221 202 227"
      fill="none" stroke="#111" strokeWidth="24" strokeLinecap="round" opacity="0.15" />
    <path d="M190 154 Q206 175 208 210 Q209 221 202 227"
      fill="none" stroke="#dea800" strokeWidth="20" strokeLinecap="round" />
    <path d="M190 154 Q197 162 201 170" stroke="#1e7a00" strokeWidth="8" fill="none" strokeLinecap="round" />
    <ellipse cx="202" cy="228" rx="9" ry="7" fill="url(#rSkin)" stroke="#3a1a08" strokeWidth="1.5" transform="rotate(15,202,228)" />

    {/* ===== NECK ===== */}
    <rect x="149" y="120" width="24" height="26" rx="12" fill="url(#rSkin)" stroke="#3a1a08" strokeWidth="2" />

    {/* ===== HEAD ===== */}
    <ellipse cx="161" cy="82" rx="46" ry="50" fill="url(#rHead)" stroke="#111" strokeWidth="2.5" filter="url(#rDrop)" />
    <ellipse cx="147" cy="63" rx="20" ry="16" fill="rgba(255,255,255,0.13)" transform="rotate(-18,147,63)" />
    <ellipse cx="161" cy="128" rx="28" ry="9" fill="rgba(0,0,0,0.1)" />

    {/* ===== HAIR (short natural) ===== */}
    <path d="M117 80 Q119 44 161 38 Q203 44 205 80 Q195 52 161 49 Q127 52 117 80 Z"
      fill="#141414" stroke="#0a0a0a" strokeWidth="1.5" />
    <circle cx="143" cy="54" r="2.2" fill="#0f0f0f" />
    <circle cx="155" cy="50" r="2.2" fill="#0f0f0f" />
    <circle cx="167" cy="49" r="2.2" fill="#0f0f0f" />
    <circle cx="179" cy="52" r="2.2" fill="#0f0f0f" />
    <circle cx="149" cy="46" r="1.5" fill="#0d0d0d" />
    <circle cx="162" cy="43" r="1.5" fill="#0d0d0d" />
    <circle cx="174" cy="46" r="1.5" fill="#0d0d0d" />
    <path d="M117 80 Q113 90 115 100 Q119 88 123 90 Z" fill="#141414" />
    <path d="M205 80 Q209 90 207 100 Q203 88 199 90 Z" fill="#141414" />

    {/* ===== HELMET ===== */}
    <path d="M115 77 Q117 38 161 32 Q205 38 207 77 Q198 54 161 51 Q124 54 115 77 Z"
      fill="url(#rHelmet)" stroke="#a08800" strokeWidth="2" />
    {/* Green racing stripe */}
    <path d="M139 34 Q161 28 183 34 Q184 55 186 77 Q161 71 136 77 Q138 55 139 34 Z"
      fill="#1e7a00" opacity="0.9" />
    {/* Brim */}
    <path d="M115 77 Q119 87 161 89 Q203 87 207 77" fill="#b08000" stroke="#a07800" strokeWidth="1.5" />
    {/* Front visor lip */}
    <path d="M131 83 Q161 92 191 83 Q178 94 161 97 Q144 94 131 83 Z" fill="#907000" stroke="#806000" strokeWidth="1" />
    {/* Vent slots */}
    <ellipse cx="129" cy="57" rx="4" ry="8" fill="rgba(0,0,0,0.35)" />
    <ellipse cx="161" cy="50" rx="4" ry="8" fill="rgba(0,0,0,0.35)" />
    <ellipse cx="193" cy="57" rx="4" ry="8" fill="rgba(0,0,0,0.35)" />
    {/* Helmet highlight */}
    <path d="M137 36 Q161 30 185 38" fill="none" stroke="rgba(255,255,255,0.35)" strokeWidth="4" strokeLinecap="round" />
    {/* Chin straps */}
    <path d="M117 83 Q115 96 119 104" stroke="#a07800" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    <path d="M205 83 Q207 96 203 104" stroke="#a07800" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    <rect x="152" y="128" width="18" height="8" rx="3" fill="#c09000" stroke="#a07800" strokeWidth="1" />

    {/* ===== EARS ===== */}
    <ellipse cx="115" cy="94" rx="9" ry="12" fill="url(#rSkin)" stroke="#3a1a08" strokeWidth="1.8" />
    <path d="M117 86 Q113 94 117 102" fill="none" stroke="#3a1a08" strokeWidth="1.5" strokeLinecap="round" />
    <ellipse cx="207" cy="94" rx="9" ry="12" fill="url(#rSkin)" stroke="#3a1a08" strokeWidth="1.8" />
    <path d="M205 86 Q209 94 205 102" fill="none" stroke="#3a1a08" strokeWidth="1.5" strokeLinecap="round" />

    {/* ===== EYES ===== */}
    <path d="M129 82 Q140 76 150 81" fill="none" stroke="#141414" strokeWidth="4" strokeLinecap="round" />
    <path d="M172 81 Q182 76 193 82" fill="none" stroke="#141414" strokeWidth="4" strokeLinecap="round" />
    <ellipse cx="140" cy="93" rx="13" ry="11" fill="white" stroke="#222" strokeWidth="1.5" />
    <ellipse cx="182" cy="93" rx="13" ry="11" fill="white" stroke="#222" strokeWidth="1.5" />
    <circle cx="141" cy="94" r="8" fill="#2a1505" />
    <circle cx="183" cy="94" r="8" fill="#2a1505" />
    <circle cx="142" cy="95" r="5" fill="#0c0800" />
    <circle cx="184" cy="95" r="5" fill="#0c0800" />
    <circle cx="144" cy="91" r="2.5" fill="white" />
    <circle cx="186" cy="91" r="2.5" fill="white" />
    <circle cx="140" cy="97" r="1" fill="rgba(255,255,255,0.5)" />
    <circle cx="182" cy="97" r="1" fill="rgba(255,255,255,0.5)" />

    {/* ===== NOSE ===== */}
    <path d="M161 103 Q155 115 153 119 Q161 123 169 119 Q167 115 161 103" fill="#6a3818" />
    <path d="M154 119 Q161 123 168 119" fill="none" stroke="#4a2810" strokeWidth="2" strokeLinecap="round" />

    {/* ===== MOUTH — wide confident grin ===== */}
    <path d="M143 128 Q161 141 179 128" fill="none" stroke="#4a2810" strokeWidth="3" strokeLinecap="round" />
    <path d="M146 130 Q161 139 176 130 Q161 134 146 130 Z" fill="white" opacity="0.88" />

    {/* Cheek blush */}
    <ellipse cx="127" cy="110" rx="11" ry="8" fill="rgba(150,55,10,0.18)" />
    <ellipse cx="195" cy="110" rx="11" ry="8" fill="rgba(150,55,10,0.18)" />
  </svg>
);

export default RiderCharacter;
